import { Controller } from "@hotwired/stimulus"

// landing v2 — แถวการ์ดที่จอมือถือ (<860px) กลายเป็นสไลด์ปัดซ้าย-ขวา (CSS .lv-swipe)
// สร้างจุดบอกตำแหน่ง + เลื่อนเองทุก autoValue ms หยุดถาวรเมื่อผู้ใช้แตะ/ปัด/กดจุด
// เดสก์ท็อปการ์ดเรียงเป็นกริด — ไม่เลื่อนเอง · ผู้ใช้ตั้งลดการเคลื่อนไหวไว้ = ไม่เลื่อนเอง
export default class extends Controller {
  static targets = ["track", "dots"]
  static values = { auto: Number }

  connect() {
    this.items = [...this.trackTarget.children]
    if (this.items.length < 2) return
    this.mobile = matchMedia("(max-width: 859px)")
    this.index = 0

    this.dotsTarget.replaceChildren(...this.items.map((_, i) => {
      const b = document.createElement("button")
      b.type = "button"
      b.setAttribute("aria-label", `${i + 1} / ${this.items.length}`)
      b.addEventListener("click", () => { this.stop(); this.go(i) })
      return b
    }))

    this.onScroll = () => this.paint(this.current())
    this.trackTarget.addEventListener("scroll", this.onScroll, { passive: true })
    this.onTouch = () => this.stop()
    for (const e of ["touchstart", "pointerdown", "wheel"]) this.trackTarget.addEventListener(e, this.onTouch, { passive: true })
    this.paint(0)

    if (this.autoValue && !matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.timer = setInterval(() => {
        if (this.mobile.matches && !document.hidden) this.go((this.index + 1) % this.items.length)
      }, this.autoValue)
    }
  }

  disconnect() {
    this.stop()
    if (!this.onScroll) return
    this.trackTarget.removeEventListener("scroll", this.onScroll)
    for (const e of ["touchstart", "pointerdown", "wheel"]) this.trackTarget.removeEventListener(e, this.onTouch)
  }

  stop() {
    clearInterval(this.timer)
    this.timer = null
  }

  step() {
    return this.items[1].offsetLeft - this.items[0].offsetLeft || 1
  }

  current() {
    return Math.min(this.items.length - 1, Math.round(this.trackTarget.scrollLeft / this.step()))
  }

  // index เก็บเองด้วย ไม่พึ่ง scroll event อย่างเดียว — แท็บที่ซ่อนอยู่ scroll event ไม่ยิง จุดจะค้าง
  go(i) {
    this.trackTarget.scrollTo({ left: this.items[i].offsetLeft - this.items[0].offsetLeft, behavior: "smooth" })
    this.paint(i)
  }

  paint(i) {
    this.index = i
    ;[...this.dotsTarget.children].forEach((d, j) => d.classList.toggle("on", j === i))
  }
}
